var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gridDisplay"},[_c('img',{staticClass:"image",attrs:{"src":_vm.url}}),_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }